var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',[_c('v-btn',{attrs:{"slot":"activator","icon":""},on:{"click":function($event){_vm.$emit('click', $event)}},slot:"activator"},[_c('v-icon',[_vm._v("edit")])],1),_c('span',[_vm._v("編集")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }